const DEFAULT_CURRENCY = 'USD';

const getCurrency = ({ companyInfo, page }) => {
  const currencyKey = `${page}_currency`;
  return companyInfo?.[currencyKey] || DEFAULT_CURRENCY;
};

export default getCurrency;
